<template>
    <div class="recommend " :class="[isJf ? 'isJf' : '']"  ref="recommend">
        <div>
            <div class="user_profiles_header">
                <div
                    class="header_bg"
                    :class="{ 
                        only_two: userDetaileArr.length === 2 ,
                        only_one: userDetaileArr.length === 1 ,
                        only_none : userDetaileArr.length === 0,
                        
                        }"
                >
                    <div class="transparent_box"></div>
                </div>
                <div class="login_box">
                    <div class="home_btn">
                        <a v-if="!isJf" href="/"></a>
                        <a href="javascript:;" @click="closePage"></a>
                    </div>
                    <!-- top_tips_bg_icon -->
                    <div v-if="isJf && false" class="home-top-bg"><!--以下服务由巨丰投顾提供--> <img src="https://cdncos.aigupiao.com/assets/jf/svg/top_tips_bg_icon.svg" /></div>
                    <div class="userUnlogin">
                        <a
                            v-if="userAvatar && userLoginId"
                            :href="origin + `/ucenter/index/`"
                            class="user_avatar"
                        >
                            <img v-if="isJf" :src="userAvatar">
                            <img v-else :src="userAvatar" alt />
                            <span v-if="isJf">个人中心</span>
                        </a>
                        <a
                            v-else
                            :href="origin + pageHref"
                        >
                            <img v-if="isJf" src="https://cdncos.aigupiao.com/assets/pc/img/2023/jf_p1.svg">
                            <img v-else
                                src="https://cdncos.aigupiao.com/assets/wap/img/icon_wap_nologin_avatar.png"
                            />
                            <span v-if="isJf">请先登录</span>
                        </a>
                    </div>
                </div>
                <!-- 未登录，非会员 -->
                <dl class="user_profiles_top" :class="[(userLoginId && is_vip == 'yes') ?'user_profiles_top2':'']">
                    <dt class="user_image">
                        <img :src="userInfo.avatar" alt />
                        <div
                            v-if="userInfo.gender && false"
                            :class="{
                                icon_gender: true,
                                male: userInfo.gender === '男',
                                female: userInfo.gender === '女',
                            }"
                        ></div>
                    </dt>
                    <dd class="user_operation">
                        <div class="user_title">
                            <h3 class="user_name">{{ userInfo.title }}</h3>
                            
                            <p
                                v-for="(item, index) in initMedal(user_medals_tail)"
                                :key="index"
                                class="user_authentication_item"
                            >
                                <span
                                    class="authentication_info"
                                >
                                    <img
                                        :src="item.image"
                                        alt
                                    />
                                </span>
                            </p>




                            <!-- <p
                                v-if="
                                    userInfo.serve_vip &&
                                    userInfo.serve_vip == 'yes'
                                "
                                class="user_authentication_item"
                            >
                                <span
                                    class="authentication_info authentication_info_killer"
                                >
                                    <img
                                        src="https://cdncos.aigupiao.com/assets/pc/img/tougu_2019.png"
                                        alt
                                    />
                                </span>
                            </p>
                            <p
                                v-else-if="
                                    userInfo.platform &&
                                    userInfo.platform == '9'
                                "
                                class="user_authentication_item"
                            >
                                <span
                                    class="authentication_info authentication_info_daren"
                                >
                                    <img
                                        src="https://cdncos.aigupiao.com/assets/pc/img/blue_v.png"
                                        alt
                                    />
                                </span>
                            </p>
                            <p
                                v-else-if="
                                    userInfo.platform &&
                                    userInfo.platform == '8'
                                "
                                class="user_authentication_item"
                            >
                                <span
                                    class="authentication_info authentication_info_daren"
                                >
                                    <img
                                        src=" https://cdncos.aigupiao.com/assets/pc/img/v_column.png"
                                        alt
                                    />
                                </span>
                            </p>
                            <p
                                v-else-if="
                                    userInfo.platform &&
                                    userInfo.platform != '8' &&
                                    userInfo.platform != '9'
                                "
                                class="user_authentication_item"
                            >
                                <span
                                    class="authentication_info authentication_info_dav"
                                >
                                    <img
                                        src="https://img1-cdn-picsh.aigupiao.com/m/image_lib/2023-09-06/5bce8ec43c43ed2b302634ffbe4a9382=39X39.png"
                                        alt
                                    />
                                </span>
                            </p>
                            <p
                                v-else-if="
                                    userInfo.is_talent &&
                                    userInfo.is_talent !== 'no'
                                "
                                class="user_authentication_item"
                            >
                                <span
                                    class="authentication_info authentication_info_daren"
                                >
                                    <img
                                        src="https://img1-cdn-picsh.aigupiao.com/m/image_lib/2023-09-06/77ac74c814fb1862323045c6d8d0f35f=39X39.png"
                                        alt
                                    />
                                </span>
                            </p> -->
                        </div>
                        <div class="past_records">
                            <div>
                                <h4>
                                    发布:&nbsp;{{ userInfo_num.publish }}
                                </h4>
                            </div>

                            <div>
                                <h4 v-if="userInfo.serve_vip && userInfo.serve_vip == 'yes' || userInfo.company == 'jf' || isJf || user_id == 1209">人气:&nbsp;{{ userInfo_num.fans }}</h4>
                                <h4 v-else>粉丝:&nbsp;{{ userInfo_num.fans }}</h4>
                                <p></p>
                            </div>
                            <div>
                                <h4>
                                    关注:&nbsp;{{ userInfo_num.follow }}
                                </h4>
                            </div>
                        </div>
                    </dd>
                </dl>
                <div class="contact_box">
                    <div class="user_authentication">
                        <p
                            v-for="(item, index) in initMedal(user_medals_tail)"
                            :key="index"
                            class="user_authentication_item"
                        >
                            <span
                                class="authentication_info"
                            >
                                <img :src="item.image" />
                            </span>
                            <span
                                class="authentication_msg authentication_msg_daren"
                                >{{item.title}}</span
                            >
                        </p>

                        <!-- && cert_no  -->
                        <p v-if="isJf && is_vip == 'yes'" class="user_authentication_item2" @click="show_cert()">
                            <img 
                                :class="[!is_cert_no ? 'show_cert':'']"
                                    src="https://cdncos.aigupiao.com/assets/pc/img/2023/jf_zk.svg"
                                    alt
                                />
                        </p>
                        <!-- <p
                            v-if="
                                userInfo.serve_vip &&
                                userInfo.serve_vip == 'yes'
                            "
                            class="user_authentication_item"
                        >
                            <span
                                class="authentication_info authentication_info_killer"
                            >
                                <img
                                    src="https://cdncos.aigupiao.com/assets/pc/img/tougu_2019.png"
                                    alt
                                />
                            </span>
                            <span
                                class="authentication_msg authentication_msg_killer"
                                >投顾认证</span
                            >
                        </p>
                        <p
                            v-else-if="userInfo.platform && userInfo.platform == '9'"
                            class="user_authentication_item"
                        >
                            <span
                                class="authentication_info authentication_info_daren"
                            >
                                <img
                                    src="https://cdncos.aigupiao.com/assets/pc/img/blue_v.png"
                                    alt
                                />
                            </span>
                            <span
                                class="authentication_msg authentication_msg_daren"
                                >机构官方账号</span
                            >
                        </p>
                        <p
                            v-else-if="userInfo.platform && userInfo.platform == '8'"
                            class="user_authentication_item"
                        >
                            <span
                                class="authentication_info authentication_info_daren"
                            >
                                <img
                                    src="https://cdncos.aigupiao.com/assets/pc/img/v_column.png"
                                    alt
                                />
                            </span>
                            <span
                                class="authentication_msg authentication_msg_daren"
                                >专栏认证</span
                            >
                        </p>
                        <p
                            v-else-if="
                                userInfo.platform &&
                                userInfo.platform != '8' &&
                                userInfo.platform != '9'
                            "
                            class="user_authentication_item"
                        >
                            <span
                                class="authentication_info authentication_info_dav"
                            >
                                <img
                                    src="https://img1-cdn-picsh.aigupiao.com/m/image_lib/2023-09-06/5bce8ec43c43ed2b302634ffbe4a9382=39X39.png"
                                    alt
                                />
                            </span>
                            <span
                                class="authentication_msg authentication_msg_dav"
                                >高手认证</span
                            >
                        </p>
                        <p
                            v-else-if="
                                userInfo.is_talent &&
                                userInfo.is_talent !== 'no'
                            "
                            class="user_authentication_item"
                        >
                            <span
                                class="authentication_info authentication_info_daren"
                            >
                                <img
                                    src="https://img1-cdn-picsh.aigupiao.com/m/image_lib/2023-09-06/77ac74c814fb1862323045c6d8d0f35f=39X39.png"
                                    alt
                                />
                            </span>
                            <span
                                class="authentication_msg authentication_msg_daren"
                                >达人认证</span
                            >
                        </p> -->
                    </div>
                    <div class="contact_btns" v-if="!isJf">
                        <div
                            class="private_vip"
                           
                            v-if="
                                userInfo.serve_vip &&
                                userInfo.serve_vip !== 'no'
                            "
                            @click="openPage('open_vip','开通')"
                        >
                            {{ is_vip == 'yes'? '已开通': '开通VIP' }}
                        </div>
                        <div v-if="Agency.u_id != userLoginId" class="private_letter" @click="openPage('letter_msg','私信')">
                            私信
                        </div>
                        <div v-if="userInfo.is_follow == 'yes'" class="private_letter attention_btn_test">
                            已关注
                        </div>
                        <div v-else class="attention_btn attention_btn_test" @click="$downapppop.open('关注')">
                            + 关注
                        </div>
                    </div>
                </div>
                <div class="user_detaile_wrap">
                    <div class="user_detaile_box">
                        <div
                            v-for="(item, index) in userDetaileArr.slice(
                                0,
                                isShowAllDetail ? 3 : 10
                            )"
                            :key="index"
                            class="user_detaile_item"
                        >
                            <p class="user_detaile_lable">
                                <span
                                    :class="[
                                        'lable_image',
                                        item.lableImageClass,
                                    ]"
                                >
                                    <img
                                        v-if="!isJf"
                                        :src="
                                            require(`@/assets/images/${item.lableImage}`)
                                        "
                                        alt
                                    />
                                    <img v-else :src="item.lableImage2">
                                </span>
                                <span class="lable_text"
                                    >{{ item.labletext }}：</span
                                >
                            </p>
                            <p :class="[ userDetaileArr.length > 3 && isShowAllDetail ? 'user_detaile_value' : 'user_detaile_value_show']">
                                {{ item.value }}

                                <span class="cert_tip" 
                                    v-if="( item.labletext == '证书' && is_vip &&  is_vip == 'no' && userInfo.serve_vip && userInfo.serve_vip == 'yes') ">
                                    开通会员查看完整资料  
                                </span>
                            </p>
                        </div>
                        <div
                            v-if="userDetaileArr.length > 3"
                            @click="handleClickAllDetail"
                            class="user_control"
                        >
                            <span class="unfold_image">
                                <img
                                    :src="
                                        isShowAllDetail
                                            ? require('@/assets/images/icon_open@2x.png')
                                            : require('@/assets/images/icon_close_triangle.png')
                                    "
                                    alt
                                />
                            </span>
                            <span>{{
                                !isShowAllDetail ? "收起" : "展开"
                            }}</span>
                        </div>
                    </div>
                </div>
                <div class="contact_btns" v-if="isJf">
                    <div
                        class="private_vip"
                        
                        v-if="
                            0 && userInfo.serve_vip &&
                            userInfo.serve_vip !== 'no'
                        "
                        @click="openPage('open_vip','开通')"
                    >
                        {{ is_vip == 'yes'? '已开通': '开通VIP' }}
                    </div>
                    <div v-if="Agency.u_id != userLoginId" class="private_letter" @click="openPage('letter_msg','私信')">
                        私信
                    </div>
                    <div v-if="userInfo.is_follow == 'yes'" class="private_letter attention_btn_test">
                        已关注
                    </div>
                    <div v-else class="attention_btn attention_btn_test" @click="$downapppop.open('关注')">
                        + 关注
                    </div>
                </div>
            </div>

            <div class="user_profiles_tabs">
                <div class="user_profiles_tab_box">
                    <div class="user_profiles_tab">
                        <div
                            v-for="(item, index) in tagsList"
                            :key="index"
                            @click="handleClickTab(item, index)"
                            :class="[
                                'tab_item',
                                tabName === item.name ? 'current_tab' : '',
                            ]"
                        >
                            <div>{{ item.title }}</div>
                        </div>
                        <div
                            class="tab-lines ub justify-content"
                            :class="['bind_' + tagsList.length, {
                                tabLinesUser : pageType == 'user'
                            }]"
                            :style="{ left: tabLineLeft + '%' }"
                        >
                            <div class="line"></div>
                        </div>
                    </div>
                </div>
                <div class="tabs-content">
                    <!-- 直播流 -->
                    <tabs-msg
                        ref="TabsMsg"
                        v-if="tabName === 'TabsMsg'"
                        :pageType="pageType"
                    ></tabs-msg>
                    <tabs-news
                        ref="TabsNews"
                        v-if="tabName === 'TabsNews'"
                        :pageType="pageType"
                    ></tabs-news>
                    <tabs-essence
                        ref="TabsEssence"
                        v-if="tabName === 'TabsEssence'"
                        :pageType="pageType"
                    ></tabs-essence>

                    <!-- vip内参 -->
                    <tabs-vip
                        ref="TabsVip"
                        v-if="tabName === 'TabsVip' "
                        :pageType="pageType"
                    ></tabs-vip>

                    <tabs-dynamic
                        ref="TabsDynamic"
                        v-if="tabName === 'TabsDynamic'"
                        :pageType="pageType"
                    ></tabs-dynamic>
                    <!-- 直播流 -->
                    <tabs-qa
                        ref="TabsQa"
                        v-if="tabName === 'TabsQa'"
                        :pageType="pageType"
                    ></tabs-qa>
                    <tabs-video
                        ref="TabsVideo"
                        v-if="tabName === 'TabsVideo'"
                        :pageType="pageType"
                    ></tabs-video>
                    <tabs-images
                        ref="TabsImages"
                        v-if="tabName === 'TabsImages'"
                        :pageType="pageType"
                    ></tabs-images>
                    <tabs-combination
                        ref="TabsCombination"
                        v-if="tabName === 'TabsCombination'"
                        :pageType="pageType"
                    ></tabs-combination>
                    <tabs-chatting-room
                        ref="TabsChattingRoom"
                        v-if="tabName === 'TabsChattingRoom'"
                        :pageType="pageType"
                    ></tabs-chatting-room>
                </div>
            </div>
        </div>
        <div class="loading_pop" v-if="!Object.keys(userInfo).length">
            <img :src="require('@/assets/images/loading.svg')" />
        </div>


        <AppFooter v-if="!isJf"></AppFooter>

        <div class="detail_jf" v-if="
            
            (isJf && 
            Agency.serve_vip == 'yes' && 
            Agency.is_open_vip_buy =='yes' && 
            Agency.video_teacher == 0 )">
            <!-- 需要后端加下 -->
            <span>{{product_price}}</span>
            <div class="js_btn" @click="openPage('open_vip','开通')">{{ is_vip == 'yes' ? '续费' : '开通'}}内参服务</div>
        </div>

    </div>
</template>
<script>
import Scroll from "@/base/scroll";
import UserProfilesApi from "@/api/userProfiles/";
import readMore from "@/components/readMore/";
import { mapActions } from "vuex";
import { scrollLoad } from "@/utils/index";
import { Toast, Dialog } from 'vant';
import circleApi from "@/api/circle/index.js";

import TabsCombination from "@/page/appProfiles/TabsCombination";
import TabsEssence from "@/page/appProfiles/TabsEssence";
import TabsImages from "@/page/appProfiles/TabsImages";
import TabsMsg from "@/page/appProfiles/TabsMsg";
import TabsVip from "@/page/appProfiles/TabsVip";
import TabsNews from "@/page/appProfiles/TabsNews";
import TabsQa from "@/page/appProfiles/TabsQa";
import TabsVideo from "@/page/appProfiles/TabsVideo";
import TabsChattingRoom from "@/page/appProfiles/TabsChattingNoData.vue";
import TabsDynamic from "@/page/appProfiles/TabsDynamic";

import AppFooter from "@/layout/AppFooter";

import * as NumApi from "@/api/userNum/index.js";

import axios from "axios";
const tagsList = {
    TeacherProfiles: [
        {
            title: "全部",
            name: "TabsMsg",
        },
        {
            title: "专栏",
            name: "TabsNews",
        },
        {
            title: "精华",
            name: "TabsEssence",
        },
        // {
        //     title: "问答",
        //     name: "TabsQa",
        // },
        // {
        //     title: "视频",
        //     name: "TabsVideo",
        // },
    ],
    UserProfiles: [
        {
            title: "动态",
            name: "TabsDynamic",
        },
        {
            title: "专栏",
            name: "TabsNews",
        },
        // {
        //     title: "自选",
        //     name: "TabsOptional",
        // },
        // {
        //     title: "组合",
        //     name: "TabsCombination",
        // },
        // {
        //     title: "相册",
        //     name: "TabsImages",
        // },
    ],
};
const StockFund = {
    1: "20万以下",
    2: "20万-50万",
    3: "50万-100万",
    4: "100万-500万",
    5: "500万以上",
};
export default {
    name: "UserProfiles",
    components: {
        Scroll,
        readMore,
        TabsMsg,
        TabsVip,
        TabsNews,
        TabsEssence,
        TabsQa,
        TabsVideo,
        TabsChattingRoom,
        TabsImages,
        TabsCombination,
        TabsDynamic,
        AppFooter
    },

    data() {
        const pageType =
            this.$route.name === "UserProfiles" ? "user" : "teacher";
        return {
            pageType: pageType,
            userInfo: {}, //用户基础资料
            userDetaileArr: [],
            isShowOtherPop: false,
            isShowAllDetail: true,
            tabLineLeft: 0,
            tagsList: tagsList[this.$route.name], //个人主页tag数据
            tabName: tagsList[this.$route.name][0].name,
            user_id: parseInt(this.$route.params.id),

            hasMore: false,
            listLoading: true,
            page: 1,
            columnStore: [],
            userInfo_num:{
                publish:0,//发布
                follow:0,//关注
                praise:0,//获赞
                fans:0,//粉丝，人气
            },//用户的统计数据资料

            is_vip:false,
            user_medals_tail: [],
            chatInfo: null,
            login_id: null, // 登录人ID
            Agency:{},//签约信息,
            pageHref: "/login/index/rd/980880418.html",
            login_user_id: "",
            origin: "",


            isJf:false,// false true
            cert_no:'',
            is_cert_no:false,
            product_price:'',

        };
    },
    watch: {
        '$store.state.user': {
            immediate: true,
            deep: true,
            handler(val, oldVal) {
                console.log('$store.state.user 登录没？',val);
                if(val.hasGetInfo){
                    //确认请求过这个接口了
                    console.log('setHasGetInfo')
                    console.log('$store.state.user',val);
                    if(!this.login_user_id) {
                        this.login_user_id = true;
                        console.log('是否多次？')
                        this.getUserInfo();
                        this.get_num();
                    }
                    //alert(this.$store.state.user.userId)

                }
            }
        }
    },
    created() {

        let originName = location.origin
        if(originName.indexOf("jfinfo.com") > -1) {
            this.isJf = true;
        }


        console.log('state.user',this.$store.state.user) 
        let current = "";
        if(location.origin.indexOf("dev") > -1) {
            current = "dev"
        }
        this.origin = "https://mobile" + current + ".aigupiao.com";

        if(this.isJf){
            //https://igpdev.jfinfo.com/
            this.origin = "https://igp" + current + ".jfinfo.com";
            this.pageHref = `/up/jf_login`;

        }



    },
    mounted() {
        this.listenScrollFn();
        this.pageHref = this.pageHref + '?redirect=' + encodeURIComponent(location.href)
    },

    computed: {
        userAvatar() {
            console.log('userAvatar',this.$store.state.user)
            //return '';
            return this.$store.state.user.avatarImgPath;
        },
        userLoginId() {
            return this.$store.state.user.userId;
        },
    },

    methods: {
        ...mapActions(["getUserProfilesInfo"]),
        initMedal,
        //获取个人主页t用户基础消息
        async getUserInfo(userOpt) {
            let data = await await this.getUserProfilesInfo({
                user_id: this.user_id,
                user_type: this.pageType,
                login_user_id:this.$store.state.user.userId,
            });
            this.$share(data.share);
            this.userInfo = data;
            console.log('data1111',data);
            this.userDetaile(data);
            if (data && data.title) {
                this.$updateTitle(`${data.title}的主页`);
            }
            //this.userInfo.is_follow = 'no';
            this.$store.state.user.is_follow = this.userInfo.is_follow;
        },
        //跳转详情页面
        goToDetail(id){
            let url = '';
            // 判断是否购买成功 - 已经购买的跳转-否则切换列表展示新的tab
            if(this.chatInfo.is_vip == 1 || this.chatInfo.chat_room_user_id == this.userLoginId) {
                url = `/Lives/detail/id/${id}/jump_type/1.html`;
            }
            else{
                //未购买成功
                if(this.Agency.is_sign == 'no'){
                    //已购买未签约情况
                    //参数都是有用的
                    //l_id  name老师名字 time购买时长 price购买价格 id购买协议id order购买订单号 
                    url = `/up/app/pay_succ?l_id=${this.user_id}&name=${this.Agency.title}&time=${this.Agency.vip_month}个月&price=${this.Agency.vip_amount}&id=${this.Agency.agreement_id}&order=${this.Agency.vip_order_id}`;
                }
                else{
                    //未购买情况
                    url = `/up/app/vip_product/wap/?l_id=${this.user_id}`
                }
            }
            location.href = url;
        },
        openPage(type,mes) {
            if(!this.userLoginId) {
                location.href = this.origin + this.pageHref;
                // 跳转登录
                return
            }

            //jf 开通会员
            if(type == 'open_vip'  && this.isJf){
                this.get_company_wap();
            }
            else{
                Toast({
                    type: "html",
                    message: "<div class='stockGroupTips'>暂不支持</div>",
                    position: "bottom"
                })
            }
            return
            if(this.pageType == 'teacher' && this.chatInfo.chat_room_status == 1) {
                let url = "";
                switch(type) {
                    case "letter_msg":
                        url = "/up/mes/" + this.Agency.u_id;
                        break;
                    case "open_vip":
                        if(this.Agency.is_sign == 'no'){
                            //已购买未签约情况
                            //参数都是有用的
                            //l_id  name老师名字 time购买时长 price购买价格 id购买协议id order购买订单号 
                            url = `/up/app/pay_succ?l_id=${this.user_id}&name=${this.Agency.title}&time=${this.Agency.vip_month}个月&price=${this.Agency.vip_amount}&id=${this.Agency.agreement_id}&order=${this.Agency.vip_order_id}`;
                        }
                        else{
                            //未购买情况
                            url = `/up/app/vip_product/wap/?l_id=${this.user_id}`
                        }
                        break;   
                }
                location.href = url;
            }
            else{
                this.$downapppop.open(mes);
            }
        },
        async getChatRoomStatus() {
            let res = await circleApi.get_chat_room_status({
                live_id: this.user_id,
                user_id: this.userLoginId
            });
            // 打成某种条件展示聊天室
            if(res.code == 1) {
                let result = res.data;
                if(result.chat_room_status == 1) {
                    this.chatInfo = result;
                    if(this.tagsList.find(item=>item.name == 'TabsVideo')){
                        this.tagsList.splice(-1,0,{
                            title: "聊天室",
                            name: "TabsChattingRoom"
                        })
                    }
                    else{
                        this.tagsList.push({
                            title: "聊天室",
                            name: "TabsChattingRoom"
                        })
                    }
                    //测试
                    // if(this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.userId == '1024762'){
                    //     alert('no2:this.Agency.is_sign:'+this.Agency.is_sign+'，条件'+(this.Agency.is_sign == 'no'));
                    // }
                    if(this.Agency.is_sign == 'no'){
                        //alert('最后一次测试:应该跳转未签约');
                        //已购买未签约情况 改为跳转到签约页面
                        //参数都是有用的
                        //l_id  name老师名字 time购买时长 price购买价格 id购买协议id order购买订单号 
                        location.href = `/up/app/pay_succ?l_id=${this.user_id}&name=${this.Agency.title}&time=${this.Agency.vip_month}个月&price=${this.Agency.vip_amount}&id=${this.Agency.agreement_id}&order=${this.Agency.vip_order_id}`;
                    }
                    else if(this.Agency.survey_sign == "no"){
                        //判断是否购买完成 但是未做风险评估
                        //直接跳转风险评估页面 Template\Mobile\H5\new_survey\normal_result.html
                        location.href = `/h5/new_survey/u_id/${this.$store.state.user.userId}/type/normal?kind=live&l_id=${this.user_id}`;
                    }

                    //这里是app的页面吗？是wap的页面吧
                    //this.investor_basic_info();
                }
            }
        },
        // 是否需要弹出投资者基本信息填写表及用户的基础数据接口：
        async investor_basic_info(){
            let res = await circleApi.investor_basic_info({
            });
            console.log('investor_basic_info',res)
            if (res.status === "success") {
                let data = res.data;
                if(data.is_popup_basic_info == 'yes'){
                    location.href = `/up/information_invest`;
                }
            } else {
                //this.$message.error(res.message);
            }},
        async get_company_wap() {
            //jf 获取开通会员地址
            let res = await circleApi.get_company_wap({
                live_id: this.user_id,
                user_id: this.userLoginId,
                source:'wap',
            });
            // 跳转 jf 链接
            if(res.code == 1 && res.data && res.data.jump_url) {
                location.href = res.data.jump_url;
            }
            else{
                Toast({
                    type: "html",
                    message: "<div class='stockGroupTips'>暂不支持</div>",
                    position: "bottom"
                })
            }
            
        },
        get_num(){
            if(this.pageType == 'teacher'){
                //测试
                let params = {
                        l_id:this.user_id,
                        u_id:this.$store.state.user.userId,
                        user_id:this.$store.state.user.userId,
                        source: "wap",
                        appversion:'11.9.0',
                };
                //测试
                // if(this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.userId == '1024762'){
                //     alert('params.u_id:'+params.u_id+'，'+'params.user_id:'+params.user_id);
                // }
                console.log('teacher',this.$store.state.user.userId)
                NumApi.teacher({
                    params:params
                })
                .then(res => {
                    
                    let data = res.data;
                    console.log('teacher data',data);
                    //"follow_num":"87915","releases_number":"440","concerns_number":0,"praised_number":"22.8\u4e07",
                    // publish:0,//发布  follow:0,//关注  praise:0,//获赞   fans:0,//粉丝，人气
                    this.userInfo_num.publish = this.set_num(data.releases_number);
                    this.userInfo_num.follow = this.set_num(data.concerns_number);
                    this.userInfo_num.praise = this.set_num(data.praised_number);
                    this.userInfo_num.fans = this.set_num(data.follow_num);
                    this.user_medals_tail = data.user_medals_tail;

                    if(data.offer_video == 'yes') {
                        this.tagsList.push({
                            title: "视频",
                            name: "TabsVideo",
                        })
                    }
                    

                    this.Agency = res.data;
                    //测试
                    // if(this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.userId == '1024762'){
                    //     alert('res.data.is_sign:'+res.data.is_sign+'，vip_order_id:'+res.data.vip_order_id);

                    //     alert('no1:this.Agency.is_sign:'+this.Agency.is_sign+'，this.vip_order_id:'+this.Agency.vip_order_id);
                    // }

                    this.getChatRoomStatus();
                    
                        // this.is_vip = data.is_vip;

                        if (data && data.cert_no !== "" && data.cert_no !== "专栏") { //  || data.is_vip == "yes"
                            this.cert_no = data.cert_no;
                            this.is_vip = data.is_vip;

                            //this.is_vip = true;
                            console.log('is_vip',this.is_vip)
                            // is_vip: "no"&& serve_vip: "yes"

                            if(data.product_price_info && data.product_price_info.length > 0){
                                this.product_price = data.product_price_info[0].price+'元/'+data.product_price_info[0].pro_label.replace('付费','');
                            }

                            
                            
                        }

                        if(this.is_vip == 'yes' && this.isJf){

                            this.tagsList.splice(3, 0,{
                                title: "VIP内参",
                                name: "TabsVip",
                            })
                        }


                    


                    //jf 跳转签约地址
                    if(this.user_id == 46 && this.Agency.is_sign == 'no' && this.Agency.sign_url){
                        location.href = this.Agency.sign_url;
                    }
                })
                .catch(err=>{
                    console.log(err)
                })
                
            }
            else{
                NumApi.user({
                    params:{
                        u_id:this.user_id,
                    }
                })
                    .then(res => {
                    
                        let data = res.data.info;
                        console.log('user info',data);
                        //用户的 "follow_num":"2","fan_num":"14520","msg_num":"133","praised_num":"15960",
                        // publish:0,//发布  follow:0,//关注  praise:0,//获赞   fans:0,//粉丝，人气
                        this.userInfo_num.publish = this.set_num(data.msg_num);
                        this.userInfo_num.follow = this.set_num(data.follow_num);
                        this.userInfo_num.fans = this.set_num(data.fan_num);
                        this.user_medals_tail = data.user_medals_tail;
                        // this.userInfo.is_talent = data.is_talent;
                        // this.userInfo.serve_vip = data.serve_vip;
                        // this.userInfo.platform = data.platform;
                        this.show_praise = (data.show_praise == 'no') ? false : true;//是否显示点赞数
                        //点赞数 或者 自选股数
                        this.userInfo_num.praise =  ( this.show_praise ? this.set_num(data.praised_num) : this.set_num(data.stock_num) ) ;
                    })
                    .catch(err=>{
                        console.log(err)
                    })
            }
        },
        show_cert(){
            if(!this.is_cert_no){
                this.$nextTick(() => {
                    let userDetaileArr = this.userDetaileArr;
                    //if(this.userLoginId) {
                        userDetaileArr.unshift({
                            labletext: "证书",
                            lableImage: "icon-medal@2x.png",
                            lableImage2:'https://cdncos.aigupiao.com/assets/pc/img/2023/jf_zs.svg',
                            lableImageClass: "lable_medal",
                            value: this.cert_no,
                        });
                    //}
                    this.userDetaileArr = userDetaileArr;
                    this.$forceUpdate()
                })
            }
            else{
                this.userDetaileArr.shift();
            }

            this.is_cert_no = !this.is_cert_no;
        },
        set_num(num){
            if(num > 10000){
                return (num/10000).toFixed(1)+'万';
            }
            else{
                return num;
            }
        },

        attentionFn() {},
        handleClickTab(item, index) {
            if (item.name === "TabsOptional") {
                this.$downapppop.open();
                return false;
            }
            // 跳转页面为聊天室
            if(item.name == 'TabsChattingRoom') {
                // 判断是否购买 - 已经购买的跳转-否则切换列表展示新的tab
                if(this.chatInfo.is_vip == 1 || this.chatInfo.chat_room_user_id == this.userLoginId) {
                    location.href = "/up/chattingRoom/" + this.user_id;
                    return false;
                }
                // 没有购买聊天室会员的入口样式
                else {

                }
                
            }
            this.tabLineLeft = (this.pageType == 'user') ? (index * 50) : (index * (100 / this.tagsList.length));
            this.tabName = item.name;
            setTimeout(() => {}, 3000);
        },
        columnListMore() {
            this.$refs[this.tabName].columnListMore();
        },
        handleClickAllDetail() {
            this.isShowAllDetail = !this.isShowAllDetail;
        },
        listenScrollFn() {
            window.document.addEventListener(
                "scroll",
                scrollLoad(this.columnListMore),
                false
            );
            // window.onscroll = scrollLoad(this.columnListMore);
        },
        userDetaile(userInfo) {
            let {
                avatar,
                releases_number,
                concerns_number,
                fans_number,
                praised_number,
                serve_vip, //是否提供Vip消息服务 --显示皇冠
                is_talent, //  只有不是老师的会显示该字段  是不是达人 --显示达人图标
                is_official, //官方老师 --显示蓝v图标
                is_elite, //是否精英高手老师 --显示星星图标
                brief, //简介
                intro, //简介
                cert_no, //执业号
                realname, //名字
                tag_list, //风格
                area, //地区
                gender, //性别
                start_year, //股龄
                stock_fund, //资金
                cert_name, //执业号+姓名
                to_ZX,
                mobile_env,
                id,
            } = userInfo;
            let userDetaileArr = [];
            if (to_ZX == "1"&& false) {
                axios
                    .get("/H5ReactZxLogin/zhongXunLogin", {
                        params: { zx_redirect: "/app_lives/center/id/" + id },
                    })
                    .then((res) => {
                        res = res.data;
                        if (res.rslt === "succ") {
                            //window.location.href = res.data;
                        }
                    });
            }

            if (intro && intro !== "") {
                userDetaileArr.push({
                    labletext: "简介",
                    lableImage: "icon-brief@2x.png",
                    lableImage2:'https://cdncos.aigupiao.com/assets/pc/img/2023/jf_jj.svg',

                    lableImageClass: "lable_brief",
                    value: intro,
                });
            } else if (brief && brief !== "") {
                userDetaileArr.push({
                    labletext: "简介",
                    lableImage: "icon-brief@2x.png",
                    lableImage2:'https://cdncos.aigupiao.com/assets/pc/img/2023/jf_jj.svg',

                    lableImageClass: "lable_brief",
                    value: brief,
                });
            }
            if (tag_list && tag_list.length !== 0) {
                let tagArr = tag_list.map((item, index) => {
                    return item.label;
                });
                let tagStr = tagArr.join("、");
                userDetaileArr.push({
                    labletext: "风格",
                    lableImage: "icon-style@2x.png",
                    lableImage2:'https://cdncos.aigupiao.com/assets/pc/img/2023/jf_fg.svg',

                    lableImageClass: "lable_style",
                    value: tagStr,
                });
            }

            // if (area && area !== "") {
            //     userDetaileArr.push({
            //         labletext: "位置",
            //         lableImage: "icon-location@2x.png",
            //         lableImageClass: "lable_location",
            //         value: area,
            //     });
            // }

            if (gender && gender !== "" && false) {
                userDetaileArr.push({
                    labletext: "性别",
                    lableImage: "icon-gender@2x.png",
                    lableImageClass: "lable_gender",
                    value: gender,
                });
            }

            if (start_year && start_year !== "" && false) {
                userDetaileArr.push({
                    labletext: "股龄",
                    lableImage: "icon-sharesofage@2x.png",
                    lableImageClass: "lable_sharesofage",
                    value: `${start_year} 年`,
                });
            }

            // if (stock_fund && stock_fund !== "") {
            //     userDetaileArr.push({
            //         labletext: "资金",
            //         lableImage: "icon-capital@2x.png",
            //         lableImageClass: "lable_capital",
            //         value:
            //             this.pageType === "user"
            //                 ? stock_fund
            //                 : StockFund[stock_fund],
            //     });
            // }
            this.userDetaileArr = userDetaileArr;
        },
        // 判断环境
        isWechat() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/micromessenger/i) == 'micromessenger') { // 判断是否在微信浏览器内
                return true;
            } else {
                return false;
            }
        },
        // 微信内置浏览器关闭
        closePageWx() {
            // isWechat是我写的一个判断当前环境是否是微信内置浏览器 的方法
            if (!this.isWechat()) return // 非微信环境下，不做处理 
            setTimeout(function() {
                if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
                    WeixinJSBridge.invoke('closeWindow', {}, function(res) {
                        if (res.err_msg == "close_window:ok") {
                            // 关闭成功的处理
                            console.log('关闭成功的处理')
                        } else {
                            // 关闭失败的处理
                            console.log('关闭失败的处理')
                        }
                    });
                }
            }, 100);
        },

        //关闭页面
        closePage() {
            if ((navigator.userAgent.indexOf('Firefox') != -1 || navigator.userAgent.indexOf('Chrome') != -1) && !this
                .isWechat()) {
                console.log('Firefox或者Chrome浏览器');
                window.location.href = 'about:blank'
                window.close()
            } else if (this.isWechat()) {
                console.log('微信内置浏览器');
                this.closePageWx()
            } else {
                console.log('其他浏览器');
                window.location.href = 'about:blank'
                window.close()
            }
        },
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@color-red: #fe484a; //主色
@color-red-high: #c7000a; //特殊情况
@color-green: #0ac890; //主色
@color-blue: #1d88d0; //全文、超链接颜色
@color-gray-small: #f7f7f7; //转发内容背影色

@color-gray-high: #222222;
@color-gray-middle: #636363;
@color-gray-low: #939393;

.border-1px(@color: #ccc, @radius: 0px, @style: solid) {
    position: relative;

    &::after {
        content: "";
        pointer-events: none;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        transform-origin: 0 0;
        border-bottom: 1px @style @color;
        border-radius: @radius;
        box-sizing: border-box;
        width: 100%;
        height: 100%;

        @media (min-resolution: 2dppx) {
            width: 200%;
            height: 200%;
            border-radius: @radius * 2;
            transform: scale(0.5);
        }

        @media (min-resolution: 3dppx) {
            width: 300%;
            height: 300%;
            border-radius: @radius * 3;
            transform: scale(0.333);
        }
    }
}

.recommend {
    // position: fixed;
    // overflow: auto;
    // top: 0;
    // width: 100%;
    // padding-bottom: 50px; 20200515
    // bottom: 0;
    //padding-bottom: 50px;
    background-color: #f5f6f7;
}

.recommend-content {
    // height: 100%;
    // overflow: hidden;
}

.tabs-content {
    // background-color: #fff;
    padding: 10px 9px 50.5px 0px ;//
    //overflow: auto;
}

.user_profiles_header {
    position: relative;
    z-index: 2;
    .header_bg {
        position: absolute;
        top: 0;
        left: 0;
        height: 241px;
        width: 100%;
        z-index: -1;
        background-image: url(https://cdncos.aigupiao.com/assets/wap/img/bg_person_index_header.png);
        background-size: cover;
        background-position: 50% center;
        background-repeat: no-repeat;
        background-clip: content-box;
        background-color: linear-gradient(
            180deg,
            rgba(90, 27, 97, 0.32) 0%,
            rgba(17, 16, 32, 0.81) 100%
        );
        &.only_two {
            height: 214px;
        }

        &.only_none{
            height: 170px;
        }

        &.only_one{
            height: 195px;
        }

        > .transparent_box {
            width: 100%;
            height: 100%;
            background: linear-gradient(
                180deg,
                rgba(90, 27, 97, 0.32) 0%,
                rgba(17, 16, 32, 0.81) 100%
            );
        }
    }

    .login_box {
        height: 58px;
        width: 100%;
        display: flex;
        padding: 0 13px 0 15px;
        justify-content: space-between;
        box-sizing: border-box;
        align-items: center;
        > .home_btn {
            width: 25px;
            height: 21px;
            background-image: url(https://cdncos.aigupiao.com/assets/wap/img/icon_wap_home.png);
            background-size: 100%;
            > a {
                display: block;
                width: 100%;
                height: 100%;
            }
        }

        >.home-top-bg {
            width: auto;
            height: 20px;
            line-height: 26px;
            // background-image: url("https://cdncos.aigupiao.com/assets/jf/svg/top_tips_bg_icon_no_text.svg");
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100%;
            color: rgba(255, 248, 214, 0.8);
            font-size: 10px;
            padding: 0 26px;

            img {
                width: auto;
                height: 100%;
                display: block;
            }
        }
        .userUnlogin {
            width: 29px;
            height: 29px;
            overflow: hidden;
            border-radius: 50%;

            > a {
                display: block;
                width: 100%;
                height: 100%;
                > img {
                    width: 100%;
                    height: 100%;
                }
                &.user_avatar {
                    width: 27px;
                    height: 27px;
                    border-radius: 50%;
                    box-sizing: border-box;
                    border: 1px solid #cccccc;
                    overflow: hidden;
                }
            }
        }
    }
    .user_profiles_top {
        display: flex;
        padding: 0 10px 0 15px;
        .user_image {
            width: 68px;
            height: 68px;
            border-radius: 50%;
            // overflow: hidden;
            border: 1px solid rgba(255, 254, 254, 0.53);
            position: relative;
            > img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
            .icon_gender {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 18px;
                height: 18px;
                z-index: 5;
                border: 1px solid #ffffff;
                border-radius: 50%;
                background-color: #ffffff;
                &.male {
                    background-image: url(https://cdncos.aigupiao.com/assets/pc/img/icon-male.png);
                    background-size: 100%;
                }
                &.female {
                    background-image: url(https://cdncos.aigupiao.com/assets/pc/img/icon-female.png);
                    background-size: 100%;
                }
            }
        }
        .user_operation {
            padding-left: 14px;
        }
        .user_title {
            display: flex;
            height: 25px;
            margin-top: 9px;
            align-items: center;
            .user_name {
                font-size: 18px;
                color: #ffffff;
            }
            .user_authentication_item {
                height: 15px;
                width: 15px;
                margin-left: 7px;
                .authentication_info {
                    width: 15px;
                    height: auto;
                    > img {
                        width: 15px;
                        display: block;
                    }
                }
            }
        }
        .past_records {
            display: flex;
            margin-top: 8px;
            > div {
                color: #ffffff;
                font-size: 12px;
                margin-left: 22px;
                &:first-child {
                    margin-left: 0;
                }
            }
        }
    }
    .contact_box {
        display: flex;
        justify-content: space-between;
        padding: 0 10px 0 17px;
        margin-top: 7px;

        .user_authentication {
            display: flex;
            align-items: center;
            margin-top: 7px;

            .user_authentication_item {
                display: flex;
                align-items: center;
                margin-left: 13px;
                height: 12px;
                &:first-child {
                    margin-left: 0;
                }
                > .authentication_info {
                    width: 12px;
                    height: auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    > img {
                        width: 100%;
                        display: block;
                    }
                    &.authentication_info_killer {
                        margin-top: -0.5px;
                    }
                }
                .authentication_msg {
                    color: #f3bf4a;
                    font-size: 11px;
                    margin-left: 3px;
                    line-height: 14px;
                }
            }
        }
        .contact_btns {
            display: flex;

            > div {
                min-width: 53px;
                height: 26px;
                padding: 0 8px;
                background: rgba(37, 37, 37, 0.33);
                border-radius: 4px;
                border: 1px solid rgba(255, 255, 255, 0.53);
                color: #ffffff;
                font-size: 12px;
                line-height: 26px;
                margin-right: 10px;
                text-align: center;
                box-sizing: border-box;

                &.attention_btn {
                    margin-right: 0;
                    background: #fe484a;
                    border: none;
                }
            }
        }
    }
    .user_detaile_wrap {
        padding: 0 10px;
        margin-top: 15px;
        .user_detaile_box {
            background: #ffffff;
            box-shadow: 0px 0px 7px 0px rgba(67, 67, 67, 0.07);
            border-radius: 7px;
            padding: 5px 16px;

            .user_detaile_item {
                display: flex;
                padding: 4px 0;
                color: #333333;
                font-size: 13px;
                .user_detaile_lable {
                    // width: 68px;
                    width: 5em;
                    height: 20px;
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 13px;
                    //lable的共有属性
                    .lable_image {
                        margin-right: 9px;

                        > img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    //简介
                    .lable_brief {
                        width: 13px;
                        height: 14px;
                    }

                    //执业
                    .lable_medal {
                        width: 15px;
                        height: 15px;
                    }

                    //风格
                    .lable_style {
                        width: 13px;
                        // height: 12px;
                    }

                    //位置
                    .lable_location {
                        width: 13px;
                        height: 16px;
                    }

                    //性别
                    .lable_gender {
                        width: 12px;
                        margin-top: 3px;
                        // height: 13px;
                    }
                    // .lable_text {
                    //   font-size: 14px;
                    // }

                    //股龄
                    .lable_sharesofage {
                        width: 13px;
                        height: 13px;
                        font-size: 0;
                    }

                    //资金
                    .lable_capital {
                        width: 13px;
                        // height: 12px;
                    }
                }
                .user_detaile_value {
                    line-height: 20px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .user_detaile_value_show{
                    line-height: 20px;
                }

                .cert_tip{
                    //font-size: 12px;
                    color: #939393;
                }
            }

            .user_control {
                position: absolute;
                width: 44px;
                height: 20px;
                bottom: 5px;
                right: 22px;
                // border-radius: 4px;
                // background: #eeeeee;
                text-align: right;
                line-height: 22px;
                color: #b9b9b9;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;

                .unfold_image {
                    width: 9px;
                    height: 5px;
                    line-height: 0;
                    margin-right: 3px;

                    > img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
}

.user_profiles_tabs {
    margin-top: 10px;
    // background: #EBEBEB;
}
.user_profiles_tab_box {
    padding: 0 15px;
    background: #ffffff;

    .user_profiles_tab {
        display: flex;
        position: relative;
        height: 42px;
        // box-shadow: 0 1px 2px rgba(0,0,0,0.1);
        // .border-1px();
        justify-content: space-around;
        align-items: center;
        font-size: 17px;
        line-height: 38px;
        color: @color-gray-high;

        .tab_item {
            text-align: center;
            width: 20%;
            border-bottom: 2px solid #ffffff;
            font-size: 16px;
            color: #333333;

            // margin-right: 15px;
            // min-width: 50px;
        }

        .tab-lines {
            bottom: 0;
            position: absolute;
            width: 20%;
            left: 0;
            transition: left 0.2s;

            &.bind_4 {
                width: 25%;
            }

            &.bind_3 {
                width: 33%;
            }
            
            &.bind_2 {
                width: 50%;
            }

            .line {
                width: 25px;
                height: 3px;
                display: inline-block;
                background-color: #fe484a;
                border-radius: 2px;
            }
        }
        
        .tabLinesUser{
            width: 50%;
        }

        // .current_tab {
        //     position: relative;
        //     &::after{
        //         height: 3px;
        //         display: block;
        //         background-color: #fe484a;
        //         border-radius: 2px;
        //         position: absolute;
        //         bottom: 0;
        //         width: 25px;
        //         left: 50%;
        //         transform: translateX(-50%);
        //         content: "";
        //     }
        // }
    }
}

.loading_pop {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f8f8f8;
    > img {
        width: 50px;
        height: 50px;
    }
}

.isJf{
    .user_profiles_tabs {
        z-index: 3!important;
        position: relative!important;
    }
    .header_bg {
        height: 300px!important;
        margin-top: 40px;
    }
    .login_box {
        height: 40px!important;
        background: #ffffff!important;
    }
    .user_profiles_top {
        padding: 29px 10px 0 15px!important;


        &.user_profiles_top2{
            // background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/jf_2.svg)!important;
            background-image: url(https://cdncos.aigupiao.com/assets/jf/svg/top_tips_bg_icon_no_text.png)!important;
            background-size: 175px 20px;
            background-repeat: no-repeat;
            background-position: top center;
        }
    }
    .user_detaile_box {
        background: none!important;
        box-shadow: none!important;
        border-radius: unset!important;
        padding: 0!important;

        .user_detaile_item{
            color: #FFFFFF!important;
        }
    }

    .home_btn{
        width: 20px!important;
        height: 20px!important;
        background-image: url(https://cdncos.aigupiao.com/assets/pc/img/2023/jf_4.svg)!important;
        background-size: 100%;
    }


    .userUnlogin{
        border: none!important;
        width: 84px!important;
        height: 21px!important;
        border-radius: unset!important;
        >a{
            width: 84px!important;
            height: 21px!important;
            display: flex!important;
            border-radius: unset!important;
            border: none!important;
            align-items: center;
            justify-content: space-between;
            img{
                width: 21px!important;
                height: 21px!important;
                border-radius: 50%;
                margin-top: 1px;
            }
            //border-radius: unset!important;
            span{
                font-size: 15px;
                color:#333333;
                line-height: 21px;
            }
        }
    }

    .user_detaile_wrap{
        margin-top: 8px;
        padding-left: 15px!important;
    }
    .user_profiles_header{
        >.contact_btns{
            display: flex;
            color: #FFFFFF;
            padding-left: 15px!important;
            margin-top: 8px;

            padding: 0 10px;
            >div{

                font-size: 14px;
                line-height: 16px;
                border-radius: 5px;
                padding: 8.5px 21px;
                background: #FFFFFF33;
                margin-right: 12px;
            }
        }
        >.contact_box{
            .user_authentication_item{
                height: 17px;
                padding: 0 7px;
                border-radius:8.5px;
                background:#FFFFFF33;
            }

            .user_authentication_item2{
                height: 16px;
                width: 22px;
                >img{
                    width: 100%;
                    height: 100%;
                    margin-left: 10px;
                    &.show_cert{
                        transform: rotate(180deg);
                    }
                }
            }
        }
    }

    .lable_image {
        width: 14px!important;
        height: 14px!important;
        margin-right: 6px!important;
    }
    .user_detaile_lable{
        width: unset!important;
        margin-right: 0!important;
    }


    .detail_jf {
        width: 100%;
        height: 50.5px;
        border-top: 1px solid #d3d3d3;
        background: #fff;
        position: fixed;
        z-index: 999;
        bottom: 0;
        display: flex;
        align-items: center;
        padding: 0 13px;
        box-sizing: border-box;
        justify-content: space-between;
        span{
            color: #FF443D;
            font-weight: 500;
            font-size: 16px;

        }

        .js_btn{
            background: #F85B55;
            width: 140px;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 15px;
            border-radius: 6px;

        }
    }
    .tabs-content{
        background: #f5f6f7;
        padding-left: 10px!important;
    }
}
</style>